<template>
  <div class="screen-saver" :style="`width:${width}px;height:${height}px; z-index: 3001;`">
    <canvas id="canvas"></canvas>
  </div>
</template>
<script>
import ScreenSaver from "../js/SceenSaver";
export default {
  data() {
    return {
      width: window.screen.width,
      height: window.screen.height
    };
  },
  mounted() {
    this.$nextTick(() => {
      let canvas = document.getElementById("canvas");
      let screenSaver = new ScreenSaver(canvas, this.width, this.height);
      screenSaver.start();
    });
    // document.addEventListener('keydown', this.event)
    // document.addEventListener('touchstart', this.event)
    // document.addEventListener('click', this.event)
  },
  methods: {
    event(e) {
      // if (isDefined(e) && isFunction(e.preventDefault)) { e.preventDefault() }
      // if (isDefined(e) && isFunction(e.stopPropagation)) { e.stopPropagation() }
      // this.hideScreenSaver()
    },
    hideScreenSaver() {
      // this.$bus.$emit(EVENTS.hideScreenSaver)
    }
  },
  beforeDestroy() {
    // document.removeEventListener('keydown', this.event)
    // document.removeEventListener('touchstart', this.event)
    // document.removeEventListener('click', this.event)
  }
};
</script>
<style lang="less" scoped>
.screen-saver {
  background: #000;
  position: fixed;
  top: 0px;
  left: 0px;
  overflow: hidden;
}

#wrap {
  width: 800px;
  height: 500px;
  border: 1px solid deeppink;
  margin-left: 10px;
  margin-top: 5px;
  float: left;
}
#input1 {
  width: 80px;
  margin: 5px auto 5px 10px;
  font-size: 0;
  float: left;
}
#div1 {
  width: 100px;
  height: 100px;
  background: hotpink;
  position: absolute;
  top: 20px;
  left: 30px;
  border-radius: 100px;
  box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.5);
}
input {
  width: 100px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-size: 18px;
  display: block;
  background: palegreen;
  margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/mainInterface/components/ScreenSaver.vue